import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useProfileSpecialistPortfolioNewStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: '32px 40px',
      borderRadius: 12,
      border: '1px solid  #E8E8E5',
      backgroundColor: '#FFF',
      [theme.breakpoints.down(900)]: {
        padding: 24
      }
    },

    //_______________________________________

    topBlockNumber: {
      marginTop: 8,
      display: 'flex',
      alignItems: 'center',
      gap: 16
    },

    blockNumber: {
      width: '100%',
      marginRight: 40,
      display: 'flex',
      alignItems: 'center'
    },

    circular: {
      color: '#E8E8E5'
    },

    circularPosition: {
      top: '2px',
      left: 0,
      bottom: 0,
      right: 0,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    divider: {
      width: '100%',
      backgroundColor: '#E8E8E5'
    },

    circularText: {
      fontSize: 14,
      fontWeight: 600,
      color: '#E52428'
    },

    action: {
      display: 'flex',
      alignItems: 'center',
      gap: 8
    },

    deleteText: {
      fontSize: 14,
      fontWeight: 500,
      color: '#7A7A75',
      whiteSpace: 'nowrap',
      textDecoration: 'underline',
      cursor: 'pointer',
      transition: '0.3s',
      '&:hover': {
        textDecoration: 'none'
      }
    },

    addText: {
      fontSize: 14,
      fontWeight: 500,
      color: '#272B2D',
      whiteSpace: 'nowrap',
      textDecoration: 'underline',
      cursor: 'pointer',
      transition: '0.3s',
      '&:hover': {
        textDecoration: 'none'
      }
    },

    //________________________________________

    top: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      [theme.breakpoints.down(900)]: {
        gap: 16
      }
    },

    infoBlock: {
      padding: '16px 24px',
      borderRadius: 8,
      backgroundColor: '#F6F6F4',
      [theme.breakpoints.down(900)]: {
        padding: 16
      }
    },

    infoText: {
      margin: 0,
      color: '#7A7A75',
      fontSize: 14
    },

    topBlock: {
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down(900)]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 12
      }
    },

    topBlockEdit: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      [theme.breakpoints.down(900)]: {
        gap: 16
      }
    },

    topHeader: {
      flexBasis: '63%',
      fontSize: 16,
      color: '#7A7A75',
      [theme.breakpoints.down(900)]: {
        fontSize: 14
      }
    },

    topHeaderEdit: {
      flexBasis: '40%',
      fontSize: 16,
      color: '#7A7A75',
      [theme.breakpoints.down(900)]: {
        fontSize: 14
      }
    },

    buttons: {
      marginTop: 16,
      alignSelf: 'flex-end',
      [theme.breakpoints.down(900)]: {
        marginTop: 8,
        alignSelf: 'center',
        display: 'flex',
        gap: 16,
        fontSize: 14
      }
    },

    buttonCancel: {
      marginRight: 16,
      width: 240,
      height: 48,
      fontSize: 16,
      textTransform: 'none',
      border: '1px solid #E8E8E5',
      [theme.breakpoints.down(900)]: {
        marginRight: 0,
        width: 'fit-content',
        height: 40,
        fontSize: 14
      }
    },

    button: {
      width: 240,
      height: 48,
      fontSize: 16,
      textTransform: 'none',
      [theme.breakpoints.down(900)]: {
        width: 'fit-content',
        height: 40,
        fontSize: 14,
        lineHeight: 'normal'
      }
    },

    //__________________________________________

    bottom: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    },

    headerBlock: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },

    header: {
      fontSize: 18,
      fontWeight: 600,
      [theme.breakpoints.down(900)]: {
        fontSize: 16
      }
    },

    bottomEdit: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      color: '#7A7A75'
    },

    edit: {
      color: '#7A7A75',
      fontSize: 14,
      fontWeight: 500,
      textDecoration: 'underline',
      cursor: 'pointer',
      transition: '0.3s',
      '&:hover': {
        textDecoration: 'none'
      }
    },

    bottomHeaderSmall: {
      color: '#B8B8B3',
      fontSize: 14,
      fontWeight: 500
    },

    bottomDescription: {
      fontSize: 16,
      [theme.breakpoints.down(900)]: {
        fontSize: 14
      }
    },

    portfolioBlock: {
      display: 'flex',
      gap: 23,
      flexWrap: 'wrap'
    },

    portfolio: {
      width: 253,
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      cursor: 'pointer',
      [theme.breakpoints.down(900)]: {
        width: 'calc(100vw - 96px)'
      },
      [theme.breakpoints.down(600)]: {
        width: 'calc(100vw - 80px)'
      }
    },

    portfolioImage: {
      borderRadius: 12
    },

    projectImages: {
      display: 'flex',
      gap: 16,
      flexWrap: 'wrap'
    },

    portfolioName: {
      fontSize: 14,
      fontWeight: 600,
      transition: '0.3s',
      height: 34,
      lineHeight: 'normal',
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    portfolioNameEdit: {
      fontSize: 16,
      fontWeight: 500,
      height: 44,
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.down(900)]: {
        fontSize: 14
      }
    },

    portfolioLikes: {
      display: 'flex',
      alignItems: 'center',
      gap: 8
    },

    portfolioLike: {
      fontSize: 14,
      fontWeight: 600
    },
    cardWrapper: {
      height: 'auto'
    },
    prevButton: {
      transform: 'rotate(180deg)'
    },
    controlButton: {
      padding: '4px'
    },
    controlButtonContainer: {
      position: 'absolute',
      right: 0,
      bottom: '-12px',
      zIndex: 999,
      display: 'flex',
      flexDirection: 'row'
    }
  })
)
